import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

const LoginPage = () => {
  const navigate = useNavigate();
  const { isAdmin, login, loading } = useAuth();

  const [password, setPassword] = useState("");
  const [error, setError]       = useState("");
  const [submitting, setSubmitting] = useState(false);

  // 이미 로그인 상태면 블로그로
  useEffect(() => {
    if (!loading && isAdmin) navigate("/blog", { replace: true });
  }, [isAdmin, loading, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!password.trim()) return;

    setSubmitting(true);
    setError("");
    try {
      await login(password);
      navigate("/blog", { replace: true });
    } catch (err) {
      setError(err.response?.data?.error || "로그인에 실패했습니다.");
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) return null;

  return (
    <div style={{
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "var(--color-background)",
      padding: "24px",
    }}>
      <div style={{
        width: "100%",
        maxWidth: "360px",
      }}>
        {/* 타이틀 */}
        <div style={{ textAlign: "center", marginBottom: "36px" }}>
          <div style={{ fontSize: "28px", marginBottom: "8px" }}>🔐</div>
          <h1 style={{
            fontSize: "20px", fontWeight: 700,
            color: "var(--color-text-primary)", margin: 0,
          }}>
            관리자 로그인
          </h1>
        </div>

        {/* 폼 */}
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: "12px" }}>
            <input
              type="password"
              placeholder="비밀번호"
              value={password}
              onChange={(e) => { setPassword(e.target.value); setError(""); }}
              autoFocus
              style={{
                width: "100%",
                padding: "12px 16px",
                border: `1px solid ${error ? "#E24B4A" : "var(--color-border-secondary)"}`,
                borderRadius: "8px",
                fontSize: "15px",
                background: "var(--color-background-secondary)",
                color: "var(--color-text-primary)",
                boxSizing: "border-box",
                outline: "none",
                transition: "border-color 0.15s",
              }}
              onFocus={(e) => { if (!error) e.target.style.borderColor = "#378ADD"; }}
              onBlur={(e) => { if (!error) e.target.style.borderColor = "var(--color-border-secondary)"; }}
            />
            {error && (
              <p style={{ margin: "6px 0 0", fontSize: "13px", color: "#E24B4A" }}>
                {error}
              </p>
            )}
          </div>

          <button
            type="submit"
            disabled={submitting || !password.trim()}
            style={{
              width: "100%",
              padding: "12px",
              border: "none",
              borderRadius: "8px",
              background: "#378ADD",
              color: "#fff",
              fontSize: "15px",
              fontWeight: 600,
              cursor: submitting || !password.trim() ? "not-allowed" : "pointer",
              opacity: submitting || !password.trim() ? 0.55 : 1,
              transition: "opacity 0.15s",
            }}
          >
            {submitting ? "확인 중…" : "로그인"}
          </button>
        </form>

        {/* 블로그로 돌아가기 */}
        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <button
            onClick={() => navigate("/blog")}
            style={{
              background: "none", border: "none", cursor: "pointer",
              fontSize: "13px", color: "var(--color-text-secondary)",
            }}
          >
            ← 블로그로 돌아가기
          </button>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;